module.exports = __webpack_public_path__ + "static/media/01_tn.640514f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/thumbnails/01_tn.jpg
// module id = 431
// module chunks = 0